import $, { each, map } from "jquery";
import * as L from "leaflet";
import { parse } from "postcss";
import { Collapse } from "bootstrap";
// import NiceSelect from "../libs/nice-select2";

let markerSVG = publicFolder + "/Images/marker.svg";
let mapPath = publicFolder + "/Json/map.geo.json";
let locations = [];
let asyncLocations = [];

/**
 * Detects whether broser is touchable
 *
 * @returns {Boolean}
 */
const isTouchDevice = () => {
  return (
    /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone/i.test(
      navigator.userAgent
    ) && "ontouchend" in document
  );
};

const sortSelect = (select) => {
  let emptyOption = select.find("option[value='']");
  let options = select.find("option").not("[value='']");
  options.sort(function (a, b) {
    return a.text.localeCompare(b.text);
  });
  select.empty().append(emptyOption).append(options);
  select.val("");
};

const MAP_CONFIG = {
  colors: {
    lightGrey: "#bebebe",
  },
  mapInitialZoom: {
    // xs: 5.7,
    // md: 5.5,
    // xl: 6.25,
    // xxl: 6.5,
    xs: 5.25,
    md: 5.25,
    xl: 6.25,
    xxl: 6.25,
  },
  mapViewCenter: {
    // [latitude, longitude]
    xs: [51, 9.9344],
    md: [51.14, 10.25],
    xl: [51.14, 10.5],
    xxl: [51.14, 11],
  },
  zoomControlPos: {
    xs: "bottomright",
    md: "bottomleft",
    xl: "bottomleft",
    xxl: "bottomleft",
  },
  iconURL: markerSVG,
  // places: [
  //   {
  //     name: "Kiel",
  //     latlong: [54.317858534414455, 10.130310316913665]
  //   }, ...
  // ]
};

const getLocations = (url) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      context: document.body,
      success: function (data) {
        resolve(data);
      },
      error: function (error) {
        reject(error);
      },
    });
  });
};

/**
 * Initializes map (Partner)
 *
 * @param {String} mapId - map element ID
 * @param {Boolean} isTouchable - is mobile (touchable) device (optional)
 */
const initMap = (mapId, isFullMap, isTouchable) => {
  // console.log(mapId, Object.getOwnPropertyDescriptors(L));

  // let inputTimeOut = null;
  let prevScreenWidth = window.innerWidth;

  const mapControls = {
    // Change 'animEnd' flag inside of animation.onProgress callback
    // to reduce the number of rendering annotation line ('beforeDraw' callback) during chart animating
    animEnd: false,
    map: {},
    geoJson: {},
    info: {},
  };

  const mapState = {
    markers: [],
    filteredMarkers: [],
    // filters (key is select name if the filter element is <select>, value is ID)
    filters: {},
  };

  if (!isFullMap) {
    MAP_CONFIG.mapInitialZoom = {
      xs: 5.25,
      md: 5.25,
      xl: 5.5,
      xxl: 5.5,
    };
    MAP_CONFIG.mapViewCenter = {
      xs: [51, 9.9344],
      md: [51, 9.5],
      xl: [51, 9.5],
      xxl: [51, 9.5],
    };
    MAP_CONFIG.mapViewBounds = [
      [56.7, 1.5],
      [45, 18],
    ];
  }

  const resetHighlight = (e) => {
    mapControls.geojson.resetStyle(e.target);
  };

  const zoomToFeature = (e) => {
    mapControls.map.fitBounds(e.target.getBounds());
  };

  const onEachFeature = (feature, layer) => {
    layer.on({
      mouseover: highlightFeature,
      mouseout: resetHighlight,
      click: zoomToFeature,
    });
  };

  const highlightFeature = (e) => {
    let layer = e.target;
    layer.setStyle({ fillColor: "#f4f3f1" });
    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }
  };

  const clearMarkers = () => {
    mapControls.map.eachLayer(function (layer) {
      if (layer instanceof L.Marker) {
        mapControls.map.removeLayer(layer);
      }
    });
  };

  /**
   * Updates map view config.
   *
   * @param {Number} screenWidth - normally passed prevScreenWidth from main scope
   */
  const setMapView = (screenWidth) => {
    const screen = screenWidth || window.innerWidth;

    // MAP_CONFIG.screen =
    //   screen < 768 ? "xs" : screen > 1199 ? "xxl" : screen > 991 ? "xl" : "md";

    if (screen > 1199) {
      // console.log("xxl");
      MAP_CONFIG.screen = "xxl";
    } else if (screen > 991) {
      // console.log("xl");
      MAP_CONFIG.screen = "xl";
    } else if (screen >= 768) {
      // console.log("md");
      MAP_CONFIG.screen = "md";
    } else {
      // console.log("xs");
      MAP_CONFIG.screen = "xs";
    }
    // console.log(
    //   "MAP_CONFIG.screen: " + MAP_CONFIG.screen + "(" + screen + ")",
    //   "font-family:monospace;font-size:12px;"
    // );
  };

  // const removeCompleteList = (list) => {
  //   $(list).removeClass("show");
  //   $(list).children().remove();
  // };

  /**
   * Search occurences in map state and build HTML with results
   *
   * @param {String} value - <input> value
   * @param {HTMLElement} completeBlock - complete container
   */
  // const autoComplete = (value, completeBlock) => {
  //   const results = [];
  //   mapState.markers.forEach((item) => {
  //     for (const filterName in item.filter) {
  //       for (let i = 0; i < item.filter[filterName].length; i++) {
  //         // Search occurences in "filter" objects with projects
  //         if (
  //           item.filter[filterName][i].title
  //             .toLowerCase()
  //             .indexOf(value.toLowerCase()) !== -1
  //         ) {
  //           const filterItem = item.filter[filterName][i];
  //           // Push to results list if project name does not repeat
  //           if (!results.some((el) => el.id === filterItem.id)) {
  //             results.push({ id: filterItem.id, text: filterItem.title });
  //           }
  //         }
  //       }
  //     }
  //   });
  //   // if (!results.length) {
  //   //   removeCompleteList(completeBlock);
  //   //   return;
  //   // }
  //   // If found results, build HTML list
  //   let listHtml = "<ul>";
  //   results.forEach((item) => {
  //     listHtml += '<li data-id="' + item.id + '">' + item.text + "</li>";
  //   });
  //   listHtml += "</ul>";
  //   // Append result list
  //   completeBlock.innerHTML = listHtml;
  //   $(completeBlock).addClass("show");
  // };

  /**
   * Handle event when map marker is pressed.
   * Renders panels with location info (if data exists)
   *
   * @param {HTMLEvents} e - Click/touch event
   */
  const showLocationInfo = function (e) {
    e.preventDefault();

    // If marker does not have 'alt' attribute
    if (!e.target.classList.contains("leaflet-div-icon")) return;

    // NOTE: If "alt" attribute is without [defis + marker index] end
    // markerId would be NaN
    let alt = $(e.target)
      .children(".leaflet-marker-icon")
      .attr("alt")
      .split("-");
    let markerId = Number(alt[1]);

    // Get location info
    let data = mapState.markers.find(function (marker) {
      return marker.uid == markerId;
    });

    let element = document.querySelectorAll(".panel-location .collapse.show");
    if (element.length > 0) {
      element.forEach(function (item) {
        let collapse = Collapse.getInstance(item);
        collapse.hide();
      });
    }
    // console.log(data);

    setTimeout(() => {
      let plElement = document.querySelectorAll(
        `.panel-location[data-uid="${data.uid}"] .collapse`
      );
      // console.log(plElement);
      if (plElement.length > 0) {
        plElement.forEach(function (item) {
          let collapse = Collapse.getInstance(item);
          collapse.show();
        });
      }

      let top = $(`.panel-location[data-uid="${data.uid}"]`).offset().top;
      top -= $(".header").height();

      if ($(".breadcrumbs").length > 0) top -= $(".breadcrumbs").height();
      // if ($(".breadcrumbs".length > 0)) top -= $(".breadcrumbs").height();
      top -= 30;

      $("html,body").animate({ scrollTop: top }, 500);
    }, 400);
  };

  /**
   * Marker filter method (after a marker is clicked or when a filter select value is changed)
   */
  const filterMarkers = function (e) {
    e.preventDefault();
    let _this = e.target;
    // console.log("==============================================");
    let filterName = "";
    let filterId = "";
    // Handle <input> filter with autocomplete
    // NOTE: Considering only select and one input exist
    if (_this.tagName === "SELECT") {
      filterName = _this.name;
      filterId = _this.value;
    } else {
      filterName = "keywords";
      filterId = $("#form-schlagworte").val().toLowerCase();
    }

    // console.log(filterId, filterName);

    // if (e.target.tagName === "LI") {
    //   removeCompleteList($(e.target).parent().parent());
    // }

    // Handle <select> filter
    // If selected option is default, remove this filter
    if (filterId === "") {
      delete mapState.filters[filterName];
    } else if (mapState.filters[filterName] === filterId) {
      // prevent action if the values repeat
      return;
    } else {
      // Filter by name and value
      // check if value is not default value
      mapState.filters[filterName] = filterId;
    }

    // If no values are in filters, show again all markers
    if (Object.keys(mapState.filters).length === 0) {
      clearMarkers();
      // Attach marker.uid end to alt attribute
      // in order to get data by click on marker
      mapState.markers.forEach(function (marker) {
        L.marker([marker.latitude, marker.longitude], {
          icon: new L.DivIcon({
            iconSize: [24.8, 31],
            iconAnchor: [12.4, 31],
            html: `<img class="icon" src="${MAP_CONFIG.iconURL}" alt="${marker.city}-${marker.uid}"><span>${marker.city}</span>`,
          }),
        }).addTo(mapControls.map);
      });
    }

    // console.log(mapState.filters);

    mapState.filteredMarkers = mapState.markers.filter(function (marker, i) {
      // if (!marker.filter) return false;
      let keys = Object.keys(mapState.filters);
      let isValid = true;

      keys.forEach((key, i) => {
        let value = mapState.filters[key];
        // console.log(key, value, marker[key]);
        if (_this.tagName === "SELECT") {
          if (marker[key].indexOf(Number(value)) === -1) isValid = false;
        } else {
          if (marker[key].toLowerCase().indexOf(value) === -1) isValid = false;
        }
        // if (filterName !== "keywords") {
        //   if (keys.indexOf(filter) === -1) continue;
        // }
        // if (marker.filter[filter].some((el) => values.indexOf(el.id) !== -1)) {
        //   return true;
        // }
      });

      return isValid;
    });

    clearMarkers();
    $("#location-projects .panel-location").slideUp(100);

    // mapState.filteredMarkers.sort((a, b) => a.company.localeCompare(b.company));

    mapState.filteredMarkers.forEach(function (marker) {
      // console.log(marker);
      $(`#location-projects [data-uid="${marker.uid}"]`).slideDown(100);

      L.marker([marker.latitude, marker.longitude], {
        icon: new L.DivIcon({
          iconSize: [24.8, 31],
          iconAnchor: [12.4, 31],
          html: `<img class="leaflet-marker-icon" src="${MAP_CONFIG.iconURL}" alt="${marker.city}-${marker.uid}"><span>${marker.city}</span>`,
        }),
      }).addTo(mapControls.map);
    });
    // console.log(mapState.filteredMarkers);
    // console.log(mapState.markers);
  };

  // ---
  // Retrieve data and generate map

  if (!mapPath) return;

  $.getJSON(mapPath, "json")
    .done(function (data) {
      if (!data || !data.features.length) {
        console.error("Städte konnten nicht geladen werden.");
        return;
      }

      setMapView();

      mapControls.map = L.map(mapId, {
        attributionControl: false,
        dragging: !isTouchable,
        tap: !isTouchable,
        gestureHandling: true,
        gestureHandlingOptions: {
          text: {
            touch:
              "Streichen Sie mit zwei Fingern über die Karte, um sie zu verschieben.",
            scroll: "Benutzen Sie strg + scroll um in die Karte zu zoomen.",
            scrollMac: "Benutzen Sie ⌘ + scroll um in die Karte zu zoomen.",
          },
        },
        zoomSnap: 0.25,
        maxBounds: MAP_CONFIG.mapViewBounds || [
          [55.4, 5.2],
          [47.2, 14.8],
        ],
        minZoom: MAP_CONFIG.mapInitialZoom[MAP_CONFIG.screen] - 1,
        maxZoom: MAP_CONFIG.mapInitialZoom[MAP_CONFIG.screen] + 3,
      }).setView(
        MAP_CONFIG.mapViewCenter[MAP_CONFIG.screen],
        MAP_CONFIG.mapInitialZoom[MAP_CONFIG.screen]
      );

      mapControls.map.zoomControl.setPosition(
        MAP_CONFIG.zoomControlPos[MAP_CONFIG.screen]
      );
      mapControls.map.scrollWheelZoom.disable();

      document.querySelector(
        "#" + mapId + " .leaflet-control-zoom-out"
      ).innerHTML = "-";

      mapControls.geojson = L.geoJson(data, {
        style: {
          opacity: 1,
          color: MAP_CONFIG.colors.lightGrey,
          weight: 2,
          dashArray: "",
          fillOpacity: 1,
          fillColor: "rgb(255,255,255)",
        },
        onEachFeature: onEachFeature,
      }).addTo(mapControls.map);

      // Resize event handler
      $(window).on("resize", function (e) {
        if (!e.isTrigger) {
          clearTimeout(this._mtimer);
          this._mtimer = setTimeout(() => {
            if (Math.abs(window.innerWidth - prevScreenWidth) < 99) {
              // Prevent from further operations for Google mobile browsers
              // (if event is not real screen change of a device)
              return;
            }

            prevScreenWidth = window.innerWidth;

            setMapView(prevScreenWidth);

            mapControls.map.zoomControl.setPosition(
              MAP_CONFIG.zoomControlPos[MAP_CONFIG.screen]
            );
            mapControls.map.setView(
              MAP_CONFIG.mapViewCenter[MAP_CONFIG.screen],
              MAP_CONFIG.mapInitialZoom[MAP_CONFIG.screen]
            );

            // console.log(
            //   "%cScreen with map resize",
            //   "color: #6f6f6f; font-family: monospace; font-size: 12px"
            // );
          }, 250);
        }
      });

      if (!isFullMap) {
        if (asyncLocations.length > 0) {
          asyncLocations.forEach(function (item) {
            let obj = item;
            delete obj.slug;
            delete obj.zip;
            // obj.category = [];
            // obj.inproject = [];
            // obj.categories = [];
            obj.longitude = parseFloat(obj.longitude);
            obj.latitude = parseFloat(obj.latitude);
            locations.push(obj);
          });
        }
      } else {
        $(".panel-location").each(function (index) {
          let obj = $(this).data();
          let array = [];
          let projects = $(this).find(".project-info-teaser");
          let inproject = [];
          projects.each(function (index) {
            inproject.push($(this).data("project-id"));
          });
          obj.inproject = inproject;
          obj.categories.forEach(function (item) {
            array.push(item.uid);
          });
          obj.category = array;
          locations.push(obj);
        });
      }

      locations.forEach(function (marker) {
        if (!marker.latitude === true) return;
        if (!marker.longitude === true) return;
        mapState.markers.push(marker);
        if (!marker.hidden) {
          let htmlCode = `<img class="leaflet-marker-icon" src="${MAP_CONFIG.iconURL}" alt="${marker.city}-${marker.uid}"><span>${marker.city}</span>`;
          if (!isFullMap) {
            htmlCode = `<img class="leaflet-marker-icon" src="${MAP_CONFIG.iconURL}" alt="${marker.city}-${marker.uid}">`;
          }
          L.marker([marker.latitude, marker.longitude], {
            icon: new L.DivIcon({
              iconSize: [24.8, 31],
              iconAnchor: [12.4, 31],
              html: htmlCode,
            }),
          })
            .bindTooltip(marker.company, {
              direction: "bottom",
            })
            .addTo(mapControls.map);
        }
      });

      $("#" + mapId + " .leaflet-marker-pane").on(
        "click",
        ".leaflet-marker-icon",
        showLocationInfo
      );
    })
    .fail((err) => {
      console.error(
        `Failed to load markers data ${err.status}: ${
          err.responseJSON ? err.responseJSON.error : ""
        }`
      );
    });

  sortSelect($("#form-map-filters [name='inproject']"));
  $("#form-map-filters [name='inproject']").on("change", filterMarkers);

  sortSelect($("#form-map-filters [name='category']"));
  $("#form-map-filters [name='category']").on("change", filterMarkers);

  $("#form-map-filters button").on("click", filterMarkers);
  $("#form-schlagworte").on("keypress", function (e) {
    if (e.key === "Enter") filterMarkers(e);
  });
};

export const init = () => {
  let attempts = 0;

  // if document.ready needed
  const whenComplete = () => {
    if (attempts > 30) return;
    attempts += 1;
    if (document.readyState === "complete") {
      if ($("#map-project-places").length > 0) {
        let doc = new DOMParser().parseFromString(infoUrl, "text/html");
        let url = doc.querySelector("body").textContent;
        getLocations(url)
          .then((data) => {
            asyncLocations = data;
            initMap("map-project-places", false, isTouchDevice());
          })
          .catch((error) => {
            console.log(error);
          });
      }
      if ($("#map-places").length > 0) {
        initMap("map-places", true, isTouchDevice());
      }
    } else {
      setTimeout(function () {
        whenComplete();
      }, 400);
    }
  };

  $(window).scroll(function () {
    if ($(this).scrollTop() > 500) {
      $(".toTop").addClass("in");
    } else {
      $(".toTop").removeClass("in");
    }
  });
  $(".toTop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 800);
    return false;
  });
  whenComplete();
};
